export const viewOptions = [
  {
    value: "table",
    label: "Table",
  },
  {
    value: "graph",
    label: "Graph",
  },
];
